import PersonaEmailsView from "./PersonaEmailsView";

export {PersonaEmailsView}
export default PersonaEmailsView
